import { Button, RHF } from "@devhop/ui";
import { PlusIcon, Trash2Icon } from "lucide-react";
import { FormDateQuarterTimeField } from "@/shared/ui/FormDateQuarterTimeField";

type FormRequestShowDatesFieldProps = {
  name?: string;
  label?: string;
};

export function FormRequestShowDatesField({
  name = "showDates",
  label = "ວັນທີ່ໂຊ",
}: FormRequestShowDatesFieldProps) {
  const { control } = RHF.useFormContext();
  const { fields, append, remove } = RHF.useFieldArray({
    control,
    name,
  });

  return (
    <div className="space-y-3">
      <p className="font-bold text-[11px] text-muted-foreground uppercase tracking-[0.28em]">
        {label}
      </p>
      <div className="space-y-3">
        {fields.map((field, index) => (
          <div key={field.id} className="flex items-start gap-2">
            <div className="min-w-0 flex-1">
              <FormDateQuarterTimeField
                name={`${name}.${index}.value`}
                allowEmpty={false}
              />
            </div>
            <Button
              type="button"
              variant="outline"
              size="icon"
              className="mt-7 shrink-0"
              disabled={fields.length <= 1}
              onClick={() => remove(index)}
              aria-label="ລຶບວັນໂຊ"
            >
              <Trash2Icon className="size-4" />
            </Button>
          </div>
        ))}
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => append({ value: "" })}
      >
        <PlusIcon className="size-4" />
        ເພີ່ມວັນໂຊ
      </Button>
    </div>
  );
}
